{
    "table_header__product_name": "Product",
    "table_header__line_status": "Status",
    "table_header__quantity_ordered": "Quantity",
    "table_header__rebate": "Rebate",
    "table_header__price": "Price",
    "table_header__total": "Total",
    "table_header__gross_margin": "GM",
    "table_header__gross_margin_percentage": "GM %",
    "table_header__encrypted_purchase_price": "Coded cost"
}
